import { render, staticRenderFns } from "./AppCard.vue?vue&type=template&id=72102ade&scoped=true"
import script from "./AppCard.vue?vue&type=script&lang=js"
export * from "./AppCard.vue?vue&type=script&lang=js"
import style0 from "./AppCard.vue?vue&type=style&index=0&id=72102ade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72102ade",
  null
  
)

export default component.exports